import { render, staticRenderFns } from "./SpecialTiers.vue?vue&type=template&id=d4fcc3b0&scoped=true&"
import script from "./SpecialTiers.vue?vue&type=script&lang=js&"
export * from "./SpecialTiers.vue?vue&type=script&lang=js&"
import style0 from "./SpecialTiers.vue?vue&type=style&index=0&id=d4fcc3b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fcc3b0",
  null
  
)

export default component.exports